import React from "react";
import Button from "@components/button/button";

export const GradientButton = ({
  href,
  target,
  rel,
  className,
  buttonText,
  onClick,
}) => {
  return (
    <Button
      onClick={onClick}
      elementType="a"
      href={href}
      target={target}
      rel={rel}
      className={className}
      buttonText={buttonText}
      style={{
        fontSize: "16px",
        padding: "20px 0px",
      }}
    />
  );
};
